import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Homework from './pages/Homework.jsx';
import Score from './pages/Score.jsx';
import Sidebar from './components/Sidebar.jsx';
import Navbar from './components/Navbar.jsx';
import LoginPage from './pages/Login.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx'; 
import Certificate from './pages/Certificate.jsx';
import LoginAsStudent from './pages/LoginAsStudent.jsx'; 
import Profile from './pages/Profile.jsx';
import MiniProfile from './pages/MiniProfile.jsx';

const Layout = () => {
  const contentRef = useRef(null);
  const location = useLocation();

  // اسکرول به بالای صفحه هنگام تغییر مسیر
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* سایدبار ثابت */}
      <div 
        className="d-none d-lg-block" 
        style={{ 
          width: '16.666%', 
          height: '100vh', 
          position: 'sticky', 
          top: 0,
          overflow: 'hidden',
          flexShrink: 0
        }}
      >
        <Sidebar />
      </div>
      
      {/* بخش محتوای اسکرول‌پذیر */}
      <div 
        ref={contentRef}
        className="col-12 col-lg-10" 
        style={{ 
          height: '100vh', 
          overflowY: 'auto',
          overflowX:'hidden',
          paddingLeft: '0',
          flex: 1
        }}
      >
        <Navbar />
        <Outlet />
      </div>
    </div>
  );
};

// مسیر محافظت‌شده
const ProtectedRoute = () => {
  const token = localStorage.getItem('accessToken');
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

// App اصلی
function App() {
  const token = localStorage.getItem('accessToken');

  return (
    <Router>
      <Routes>
        
        <Route path="/login-as-student" element={<LoginAsStudent />} />

        {/* صفحات عمومی */}
        <Route
          path="/login"
          element={token ? <Navigate to="/" replace /> : <LoginPage />}
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* صفحات محافظت‌شده */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="roadmap" element={<Profile />} />
            <Route path="homework" element={<Homework />} />
            <Route path="score" element={<Score />} />
          </Route>
          <Route path="certificate/:id" element={<Certificate />} />
          <Route path="miniprofile" element={<MiniProfile/>}/>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;